import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { UtilService } from '../../_shared/services/util.service';

import { atLeastOneCheckboxCheckedValidator } from '../../_shared/validators/atLeastOneCheckboxCheckedValidator';

import { Category } from '../shared/category.model';
import { CategoryModalService } from '../shared/category-modal.service';
import { CategoryService } from '../shared/category.service';

@Component({
  selector: 'app-category-detail',
  templateUrl: './category-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CategoryDetailComponent implements OnInit {
  constructor(
    private categoryService: CategoryService,
    private categoryModalService: CategoryModalService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private utilService: UtilService
  ) {}

  @Input() category: Category;
  @Input() mode: string;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private savedCategory = new EventEmitter<Category>();
  @Output() private canceledCategory = new EventEmitter();

  form: FormGroup;

  formSubmited = false;

  createMode = false;
  editMode = false;
  viewMode = false;

  productTypes = CONSTANTS.ALL_PRODUCT_TYPES;

  allProductTypesChecked = false;

  serverErrors = [];
  sendingForm = false;

  // private categoryCopy;

  ngOnInit() {
    this.setCategoryForm();

    if (this.category.id) {
      this.setItemOptions(this.category, this.mode);
    } else {
      this.createMode = true;

      // In case we don't initialize the object in the parent component - to work with setProductTypesChecked
      if (!this.category.type) {
        this.category.type = {};
      }
    }

    this.setProductTypesChecked();
  }

  // Try to replace this, avoid get as possible
  get productTypesFormArray() {
    return this.form.controls['type'] as FormArray;
  }

  checkAllProductTypes(event) {
    this.allProductTypesChecked = event.target.checked; // checked

    this.productTypesFormArray.controls.forEach((x) => {
      x.setValue(event.target.checked);
    });
  }

  checkProductType(event) {
    if (!event.target.checked) {
      this.allProductTypesChecked = false;
    }
  }

  // Referenced from app-translation-options
  onOpenedTranslation(language) {
    this.categoryModalService.openCategoryTranslation(this.category, language);
  }

  // Referenced from app-item-detail-form-actions
  onSavedCategory() {
    this.formSubmited = true;

    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const fields = ['name', 'description'];
    const formData = this.utilService.deleteNullFields(fields, this.form.value);

    formData.type = this.utilService.productTypesFormArrayChecked(
      this.productTypes,
      this.productTypesFormArray
    );

    // console.log(formData);
    // return;

    this.sendingForm = true;

    this.categoryService
      .saveCategory(this.category.id, formData, this.defaultLanguage.lang)
      .subscribe({
        next: (response) => {
          let msg = '';

          if (this.editMode) {
            msg = 'MODIFIED_CATEGORY';

            // needed if we want to keep the page opened or if used in page
            this.category = response;
            this.setItemOptions(response);
          } else {
            msg = 'NEW_ADDED_CATEGORY';
            // this.category = response; // reload item - needed ?
          }

          this.alertService.open(msg);

          // this.setItemOptions(response);

          this.sendingForm = false;

          this.savedCategory.emit(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    // if (this.editMode) {
    //   this.cancelEdit();
    //   return;
    // }

    this.canceledCategory.emit();
  }

  // Referenced from app-item-detail-form-actions
  onEditedCategory() {
    this.editMode = true;
    this.viewMode = false;

    this.enableDisableProductTypes('enable');
  }

  // private cancelEdit() {
  //   this.category = this.categoryCopy;
  //   this.setItemOptions(this.category);
  // }

  private setItemOptions(category, mode = '') {
    this.createMode = false;
    this.editMode = false;
    this.viewMode = true;

    if (mode === 'edit') {
      this.onEditedCategory();
    }

    // this.categoryCopy = JSON.parse(JSON.stringify(category));
  }

  private setCategoryForm() {
    this.form = this.formBuilder.group({
      name: [
        this.category.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')), // Problems with German characters
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.category.description],
      type: new FormArray([], atLeastOneCheckboxCheckedValidator(1)),
    });
  }

  private setProductTypesChecked() {
    for (let productType of this.productTypes) {
      let isSelected = Object.keys(this.category.type).some((x) => x === productType.type);

      this.productTypesFormArray.push(new FormControl(isSelected));
    }

    const option = this.viewMode ? 'disable' : 'enable';

    this.enableDisableProductTypes(option);
  }

  private enableDisableProductTypes(option) {
    this.productTypesFormArray.controls.forEach((x) => {
      if (option === 'enable') {
        x.enable();
      } else {
        x.disable();
      }
    });
  }
}
